import * as React from 'react';
import PropTypes from 'prop-types';

const SearchInput = ({ id, name, type, onChange, placeholder, value, inputClassName }) => {
  const sanitize = (v) => (v || '').replace(/&/g, '');

  const handleChange = (e) => {
    const filtered = sanitize(e.target.value);
    if (onChange) {
      // send a synthetic event-like object so parent handlers keep working
      onChange({ target: { name: name || id, value: filtered } });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === '&') e.preventDefault();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData('text');
    const filtered = sanitize(paste);
    const el = e.target;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const newVal = el.value.slice(0, start) + filtered + el.value.slice(end);
    if (onChange) onChange({ target: { name: name || id, value: newVal } });
  };

  return (
    <div className="relative w-full sm:w-auto">
      <div className="flex absolute inset-y-0 left-0 items-center pl-4 pointer-events-none top-1/2 -translate-y-1/2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <g opacity="0.5">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.1441 12.535C11.8739 11.3748 13.1464 8.22136 11.9863 5.49152C10.8261 2.76168 7.67265 1.4892 4.94281 2.64936C2.21297 3.80951 0.94049 6.96297 2.10064 9.69281C3.2608 12.4226 6.41426 13.6951 9.1441 12.535Z"
              stroke="#54616D"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.8408 11.3896L15.0061 15.5556"
              stroke="#54616D"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      </div>
      <input
        type={type}
        id={id}
        name={name}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onPaste={handlePaste}
        placeholder={placeholder}
        value={value}
        autoComplete="off"
        className={`py-[9px] rounded-input dark:bg-shoorah-darkBgTabColor dark:text-white dark:border-shoorah-darkBorder pl-[42px] w-64 max-[426px]:w-full sm:w-[300px] lg:w-[350px] appearance-none border-[1.5px] border-shoorah-borderGray px-3 placeholder-shoorah-lightBlack dark:placeholder-white placeholder:text-sm focus:border-shoorah-primary focus:outline-none focus:ring-shoorah-primary sm:text-sm !leading-[22px] ${inputClassName}`}
      />
    </div>
  );
};

SearchInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.any,
  value: PropTypes.any,
  onChange: PropTypes.func
};
export default SearchInput;
